/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Input } from '@atoms';
import Form from '@organisms/Form';

const YouTubeUrlField = ({ placeholder, ...props }) => (
  <Form.Item {...props}>
    <Input placeholder={placeholder} />
  </Form.Item>
);

export default YouTubeUrlField;
